module.exports = __webpack_public_path__ + "img/107.2.2a6a2cb1.png";